import { REACT_APP_API } from '../../config'
import axios from 'axios'

export default async function generateIndividualPDF(pages) {
    const body = JSON.parse(JSON.stringify({
        dashboard_individual: pages
    }))
    const {data} = await axios({
        method: 'post',
        url: `${REACT_APP_API}/dashboard/generatePDF/individual`,
        data: body,
        timeout: 300000, // 5 minutos
        responseType: 'text/html'
    })
    if(data){
        const file = new Blob([data], { type: 'text/html' })
        const fileURL = URL.createObjectURL(file)
        window.open(fileURL, "_blank")
        return true
    } else return null
}